import { Injectable } from '@angular/core';
import {EntitiesAutocompleteSearchType, Entity} from "./entities-autocomplete.model";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class EntitiesAutocompleteService {

  constructor(private httpClient: HttpClient) { }

  public getSuggestions = async (hint: string, facets: string, locale: string, profile: string) : Promise<Entity[]> => {
    //TODO DEJO EL PROFILE ESTE TEMPORALMENTE HASTA QUE CREEN EL NUESTRO.
    const url = `/suggestions?hint=${hint}&facets=${facets}&locale=${locale}&profile=autocomplete-${profile}`;
    try {
      const response = (await this.httpClient.get(url).toPromise() as any)
      return response.items
        .map(({ id, display, target: { code, iata, type } }) => ({ display, type, code: code || iata, gid: id}))
    } catch (e) {
      throw `Error ajax ${url}`;
    }
  }

  // @ts-ignore
  private createSuggestion = (): Suggestion => {

  }

  public getEntity = async (id: string, locale: string, type: EntitiesAutocompleteSearchType): Promise<Entity> => {
    if (id === '') {
      return Promise.reject("No id defined");
    }
    const url = `/suggestions/${type}/${id}?locale=${locale}`;
    try {
      const { id, display, target: { code, iata } } = await this.httpClient.get(url).toPromise() as any;
      return {
        display,
        code: code || iata,
        gid: id,
      };
    } catch (e) {
      throw `Error ajax ${url}`;
    }
  }
}
